import { render, staticRenderFns } from "./section-results-info-tips.vue?vue&type=template&id=57776d06&scoped=true&"
import script from "./section-results-info-tips.vue?vue&type=script&lang=js&"
export * from "./section-results-info-tips.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "57776d06",
  null
  ,true
)

export default component.exports